export default [
  {
    nome: 'Caixa de entrada',
    icon: 'fal fa-envelope',
    routeGroup: 'certificacao/caixa-entrada',
    permissao: 'VIEW_CAIXA_ENTRADA'
  },
  {
    nome: 'Em certificação',
    icon: 'fal fa-file-signature',
    routeGroup: 'certificacao/em-certificacao',
    permissao: 'VIEW_CAIXA_EM_CERTIFICACAO'
  },
  {
    nome: 'Certificados',
    icon: 'fal fa-folder-open',
    routeGroup: 'certificacao/certificados',
    permissao: 'VIEW_CAIXA_CERTIFICADOS'
  }
]



// WEBPACK FOOTER //
// ./src/libs/constants/painel/certificacao/menu.js